"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ProductItemLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _productHelpers = require("../../helpers/productHelpers");
var _labelPropTypes = require("../productTableLabels/defaults/labelPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ProductItemLabel = exports.ProductItemLabel = function ProductItemLabel(_ref) {
  var labelKey = _ref.labelKey,
    labelDefinition = _ref.labelDefinition,
    brandFootnotes = _ref.brandFootnotes;
  var label = labelDefinition.label,
    subLabel = labelDefinition.subLabel,
    footnote = labelDefinition.footnote,
    footnoteLocation = labelDefinition.footnoteLocation,
    tooltip = labelDefinition.tooltip;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "labelText ".concat(tooltip ? 'withTooltip' : '')
  }, label, footnote && !footnoteLocation && /*#__PURE__*/_react["default"].createElement("sup", null, (0, _productHelpers.GetFootnoteNumber)(labelKey, brandFootnotes)), subLabel && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("small", null, subLabel)), tooltip && /*#__PURE__*/_react["default"].createElement(_components.Tooltip, {
    icon: "info",
    customCssClass: "shiftRight"
  }, tooltip, footnote && footnoteLocation === 'tooltip' && /*#__PURE__*/_react["default"].createElement("sup", null, (0, _productHelpers.GetFootnoteNumber)(labelKey, brandFootnotes))));
};
ProductItemLabel.propTypes = {
  labelKey: _propTypes["default"].string,
  labelDefinition: _propTypes["default"].shape(_labelPropTypes.LabelPropTypes),
  /* eslint-disable-next-line react/forbid-prop-types */
  brandFootnotes: _propTypes["default"].any
};
var _default = exports["default"] = {
  ProductItemLabel: ProductItemLabel
};